import TokenTable from "~/components/TokenTable/TokenTable";
import * as React from 'react';
export default {
  TokenTable,
  React
};